import { colors } from '../../../abstracts';
import { styled } from 'styled-components';
export const DrawerStickyAction = styled.div.withConfig({
  componentId: "aui__sc-1ytw7kj-0"
})(["display:flex;flex-direction:column;box-sizing:border-box;z-index:2147482648;position:sticky;bottom:0;left:0;right:0;background-color:", ";pointer-events:all;overflow:visible;"], colors.white);